import React, { useState } from "react";
import Image from "pages/_components/Image";
import { instanceOf } from "prop-types";
import FormmatedText from "../CustomText/_components/FormmatedText";
import Dropdown from "../Dropdown";
import { customButtonPropType, defaultCustomButtonPropType } from "./customButtonPropType";
import Button from "../Button";
import ButtonOption from "./_components/ButtonOption";
import { MobileButtons } from "../header";
import Action from "../Action";
import { resizableRoute as resizableComponent } from "../Resizable";

const CustomButton = ({
    func,
    icon,
    options,
    loading,
    type,
    pullRight,
    widthXl,
    modalContent,
    linkTo,
    isMobile,
    ...textProps
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const openModal = () => {
        // dispatch(templateActions.createTemplate());
        setIsModalVisible(true);
    };
    const openModalProps = {
        onClick: openModal,
        "aria-haspopup": "dialog",
        "aria-expanded": isModalVisible,
    };

    const customClass = `${textProps.className}`;

    const handleClick = (e) => {
        if (type !== "submit") {
            e.stopPropagation();
            e.preventDefault();
        }

        func();

        // if (!!linkTo) {
        //     dispatch(routerActions.replace({ pathname: linkTo }));
        // }
    };

    const MenuOptionsWrap = ({ wrapOptions }) => {
        if (isMobile) {
            return (
                <MobileButtons>
                    {wrapOptions.map((option) => (
                        <Action
                            className={option.className}
                            labelKey={option.text}
                            handleClick={option.func}
                            to={option.linkTo}
                            disabled={option.disabled}
                        />
                    ))}
                </MobileButtons>
            );
        }
        return (
            <div onClick={handleClick} aria-hidden="true" className={customClass}>
                <Dropdown image={icon} pullRight={pullRight} widthXl={widthXl} buttonClass="custom-button">
                    {wrapOptions.map((option) => (
                        <ButtonOption {...option} key={option.text} />
                    ))}
                </Dropdown>
            </div>
        );
    };
    MenuOptionsWrap.propTypes = {
        wrapOptions: instanceOf(Array).isRequired,
    };

    return options.length ? (
        <>{isMobile &&
            <Image src={icon} className={"svg-icon"} /> 
        }
        <MenuOptionsWrap wrapOptions={options} />
        </>
    ) : (
        <Button
            type={type === "submit" ? "submit" : "button"}
            onClick={handleClick}
            className={customClass}
            image={icon}
            loading={loading}
            {...(modalContent ? openModalProps : {})}
            {...textProps}>
            {icon && <Image src={icon} className="svg-icon" />}
            <FormmatedText text={textProps.text} textType={textProps.textType} />
        </Button>
    );
};

CustomButton.propTypes = customButtonPropType;
CustomButton.defaultProps = defaultCustomButtonPropType;

export default resizableComponent(CustomButton);
